var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgB2B(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 29,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.207 21.822H5.903l.859-2.437a.978.978 0 0 1 .911-.672h3.763c.406 0 .77.268.912.672l.859 2.437z",
    fill: "#000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.753 22.087 9.086-.528.554 3.377-9.544.08-.096-2.93z",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.654 21.166.563-1.599a.489.489 0 0 1 .456-.336h3.763c.203 0 .385.134.456.336l.563 1.599c.024.066-.022.138-.09.138H6.745c-.067 0-.113-.072-.09-.138z",
    fill: "#FAFAFA",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.199 20.267H8.911a.168.168 0 0 1-.168-.167v-.356c0-.092.075-.168.168-.168h1.288c.092 0 .167.075.167.168v.356a.167.167 0 0 1-.167.167z",
    fill: "#000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.609 19.915h-.108a.108.108 0 0 1-.108-.108v-.583h.324v.583c0 .06-.048.108-.108.108zM6.122 25.29v.916c0 .162.123.293.276.293h.79c.152 0 .276-.131.276-.293v-.916H6.122zM11.722 25.29v.916c0 .162.123.293.275.293h.79c.153 0 .276-.131.276-.293v-.916h-1.341zM6.755 22.45c.437 0 .793.378.793.843 0 .465-.356.844-.793.844-.437 0-.793-.379-.793-.844 0-.465.356-.844.793-.844zm0 .254c-.305 0-.553.265-.553.59 0 .324.248.588.553.588.305 0 .554-.264.554-.589 0-.324-.249-.589-.554-.589zM12.355 22.45c.437 0 .792.378.792.843 0 .465-.355.844-.792.844-.438 0-.793-.379-.793-.844 0-.465.355-.844.793-.844zm0 .254c-.305 0-.554.265-.554.59 0 .324.249.588.554.588.305 0 .553-.264.553-.589 0-.324-.248-.589-.553-.589zM11.968 6.61H7.14a.23.23 0 0 1-.23-.23V4.618c0-.356.29-.645.646-.645h3.995c.356 0 .646.29.646.645V6.38a.23.23 0 0 1-.23.23zM7.37 6.15h4.367V4.618a.186.186 0 0 0-.186-.186H7.557a.186.186 0 0 0-.186.186V6.15z",
    fill: "#000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.381 9.488H4.727a.23.23 0 0 1-.23-.23V6.84c0-.38.31-.69.69-.69h8.735c.38 0 .69.31.69.69v2.418a.23.23 0 0 1-.23.23zm-9.424-.46h9.195V6.84a.23.23 0 0 0-.23-.23H5.187a.23.23 0 0 0-.23.23v2.189z",
    fill: "#000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.543 28.108H.566a.436.436 0 0 1-.436-.436v-.966c0-.24.195-.436.436-.436h17.977c.24 0 .435.195.435.436v.966c0 .24-.195.436-.435.436zM.59 27.648h17.929v-.919H.589v.92zM6.106 13.56H4.267a.46.46 0 0 1-.46-.459v-2.298a.46.46 0 0 1 .46-.46h1.84a.46.46 0 0 1 .459.46V13.1a.46.46 0 0 1-.46.46zm-1.839-2.757V13.1h1.84v-2.298h-1.84zM10.474 13.56h-1.84a.46.46 0 0 1-.459-.459v-2.298a.46.46 0 0 1 .46-.46h1.839a.46.46 0 0 1 .46.46V13.1a.46.46 0 0 1-.46.46zm-1.84-2.757V13.1h1.84v-2.298h-1.84zM14.841 13.56h-1.839a.46.46 0 0 1-.46-.459v-2.298a.46.46 0 0 1 .46-.46h1.84a.46.46 0 0 1 .459.46V13.1a.46.46 0 0 1-.46.46zm-1.839-2.757V13.1h1.84v-2.298h-1.84z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.186 26.728H2.854a.23.23 0 0 1-.23-.23V9.712c0-.377.307-.683.684-.683h12.425c.377 0 .683.306.683.683v16.786a.23.23 0 0 1-.23.23zm-13.102-.46h12.873V9.712c0-.123-.1-.224-.224-.224H3.308c-.123 0-.224.1-.224.224v16.556z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.957 4.432h-.805a.23.23 0 0 1-.23-.23V.697a.633.633 0 0 1 1.264 0v3.505a.23.23 0 0 1-.23.23zm-.575-.46h.345V.698a.173.173 0 0 0-.345 0v3.276z",
    fill: "#000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.43 18.882a.342.342 0 0 1-.242.583.342.342 0 1 1 .241-.583zM14.024 18.545a.182.182 0 0 0 0-.258 1.182 1.182 0 0 0-1.672 0 .182.182 0 0 0 .257.258.818.818 0 0 1 1.158 0 .182.182 0 0 0 .257 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.934 17.87a1.773 1.773 0 0 1 2.508 0 .182.182 0 0 0 .257-.257 2.137 2.137 0 0 0-3.023 0 .182.182 0 0 0 .258.256z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgB2B);
export default __webpack_public_path__ + "static/media/b2b.0134e449f2c4c9864008d6b5ae54f270.svg";
export { ForwardRef as ReactComponent };